module.exports = __webpack_public_path__ + "static/img/computer4.48e27de.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product-images/computer4.jpg
// module id = 1XMC
// module chunks = 0